import { Modal, SwipeableDrawer, styled } from '@mui/material';
import Box from '@mui/material/Box';
import { FC } from 'react';

import { useActions } from '../../hooks/useActions';
import { useUser } from '../../hooks/useUser';

import Auth from './Auth';
import styles from './AuthDialog.module.sass';

interface IModalProps {
  open: boolean;
  handleOpen?: () => void;
  handleClose: () => void;
  defaultType: string;
  defaultVisible?: boolean;
  basketCode?: boolean;
  window: string;
  position?: 'bottom' | 'left' | 'right' | 'top' | undefined;
}

const AuthDialog: FC<IModalProps> = ({
  open,
  handleClose,
  defaultType,
  handleOpen,
  defaultVisible,
  basketCode,
  window,
  position,
}) => {
  const { setFormType, setAuthVisible } = useActions();
  const { formType, visibleAuthDialog } = useUser();
  const handleCloseModal = () => {
    setFormType('phone');
    setAuthVisible(!visibleAuthDialog);
  };
  return (
    <Modal
      className={styles.modal}
      keepMounted
      onClose={handleCloseModal}
      open={!!visibleAuthDialog}
    >
      <Box className={styles.wrapper}>
        {formType === 'email' && <Auth type="email" />}
        {formType === 'phone' && <Auth type="phone" />}
        {formType === 'code' && <Auth type="code" />}
      </Box>
    </Modal>
  );
};
export default AuthDialog;
